import { render, staticRenderFns } from "./DealerManagedContactModal.vue?vue&type=template&id=b1f1b70a"
import script from "./DealerManagedContactModal.vue?vue&type=script&lang=js"
export * from "./DealerManagedContactModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports